import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12 0c6.613 0 12 5.387 12 12s-5.387 12-12 12S0 18.613 0 12 5.387 0 12 0m.75 12.707h4.2v-1.5h-4.2v-4.2h-1.5v4.2h-4.2v1.5h4.2v4.2h1.5z"
    }, null, -1)
  ]))]))
}
export default { render: render }